import { render, staticRenderFns } from "./TradeLog.vue?vue&type=template&id=a115d208&scoped=true&"
import script from "./TradeLog.vue?vue&type=script&lang=js&"
export * from "./TradeLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a115d208",
  null
  
)

export default component.exports